export const shopFooterDisclaimers = () => {
  return Sq.SqShopFooter && Sq.SqShopFooter.disclaimers
    ? Sq.SqShopFooter.disclaimers
    : [];
};
